// src/components/admin/AdminLekhi.js
import React, { useState } from 'react';
import AdminLekhiContent from './AdminLekhiContent';
import AdminLekhiPlans from './AdminLekhiPlans';

const SUB_TABS = [
  { id: 'content', label: 'Content' },
  { id: 'plans', label: 'Plans' }
];

export default function AdminLekhi() {
  const [activeSubTab, setActiveSubTab] = useState('content');

  return (
    <div>
      <div style={{
        display: 'flex',
        gap: '8px',
        borderBottom: '1px solid #e9ecef',
        marginBottom: '20px',
        paddingBottom: '0'
      }}>
        {SUB_TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveSubTab(tab.id)}
            style={{
              background: 'none',
              border: 'none',
              padding: '10px 20px',
              fontSize: '15px',
              fontWeight: activeSubTab === tab.id ? 700 : 500,
              color: activeSubTab === tab.id ? '#007fff' : '#666',
              cursor: 'pointer',
              borderBottom: activeSubTab === tab.id ? '3px solid #007fff' : '3px solid transparent',
              marginBottom: '-1px'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeSubTab === 'content' && <AdminLekhiContent />}
      {activeSubTab === 'plans' && <AdminLekhiPlans />}
    </div>
  );
}